import MobileStatsPageHeader from '../../header/MobileStatsPageHeader';
import Footer from '../../Footer';
import BottomMenuMobile from '../../bottom-menu/BottomMenuMobile';
import HelpContent from '../../utility/HelpContent';

const headerHeight = 80;
const bottomMenuHeight = 100;
const footerHeight = 24;

const styles = {
  main: {
    height: `calc(100vh - ${headerHeight}px - ${bottomMenuHeight}px - ${footerHeight}px)`,
    display: 'flex',
    flexDirection: 'column',
    background: '#1b3665',
    padding: 15,
    overflowY: 'scroll',
  },
};

const MapPageMobile = () => (
  <>
    <MobileStatsPageHeader height={headerHeight} />
    <div style={styles.main}>
      <HelpContent />
    </div>
    <BottomMenuMobile height={bottomMenuHeight} />
    <Footer height={footerHeight} />
  </>
);

export default MapPageMobile;
